<template>
  <div class="git-list">
    <DnsRecord ref="dnsRecord"></DnsRecord>
    <DnsRecordList ref="DnsRecordList"></DnsRecordList>
    <Row class="" style="border-radius: 4px">
      <Col :md="nodeListSpan" v-show="nodeListShow">
        <Card>
          <nodeList ref="nodeList" v-on:nodeChange="init"></nodeList>
        </Card>
      </Col>
      <Col :md="contentSpan" style="border-left: 6px solid #f5f7f9;">
        <GroupMember ref="GroupMember" :groupId="groupId" :node="node"></GroupMember>
        <Card shadow>
            <Row class="sm-pc-w100">
              <Col :md="22">
                <span>
                  <Button @click="nodeListShowBtn(false)" v-show="nodeListShow" type="primary" size="small" :style="{float: 'left', marginRight: '10px'}" class="mob-hidden">
                    <Icon type="ios-arrow-back" />
                  </Button>
                  <Button @click="nodeListShowBtn(true)" v-show="!nodeListShow" type="primary" size="small" :style="{float: 'left', marginRight: '10px'}">
                    <Icon type="ios-arrow-forward" />
                  </Button>
                </span>
                <Form :model="tableSearchForm" ref="tableSearchForm" inline :label-width="60" @submit.native.prevent>
                  <FormItem label="域名名称">
                    <Input v-model="tableSearchForm.name" style="width: 200px" />
                  </FormItem>
                  <FormItem :label-width="0" class="mob-align-right">
                    <Button type="primary" @click="getTableData()">搜索</Button>
                    <Button style="margin-left: 8px" @click="clearSearchForm">重置</Button>
                    <RadioGroup v-model="company" type="button" style="margin-left: 8px" >
                      <Radio label="傲基"></Radio>
                      <Radio label="猿人"></Radio>
                  </RadioGroup>
                  <RadioGroup v-model="dnsTarget" type="button" style="margin-left: 8px" >
                      <Radio label="aliyun">阿里云(批量解析)</Radio>
                      <Radio label="west">西数(批量解析)</Radio>
                  </RadioGroup>
                    <Button style="margin-left: 20px"  type="success" @click="batchConfig" :loading="loadingConfig">批量配置解析</Button>
                    <Button style="margin-left: 10px"  type="warning" @click="batchCheck" :loading="loadingCheck">批量验证DNS</Button>
                  </FormItem>
                </Form>
              </Col>
              <Divider />
                <div>
                  <span>已选域名(<b>{{ selectRow.length }}</b>)：<a v-on:click="emptyServer" v-if="selectRow.length">清空 </a> </span>
                  <Tag color="primary" closable v-for="(item, index) in selectRow" :key="'domain_' + index" @on-close="removeServer('remove', item)">{{ item }}</Tag>
                </div>
                <Divider />
              <!-- <Col span="24" :md="2" class="align-right">
                <Button
                  style="float: right;"
                  @click="edit()"
                  type="primary"
                  :style="{marginBottom: '10px'}"
                  v-if="$store.state.user.superuser"
                  icon="md-add">添加Gitlab群组</Button>
              </Col> -->
            </Row>
            <Alert v-if="listError" type="warning" show-icon>获取数据失败</Alert>
            <Table
              v-else
              stripe
              border
              highlight-row
              :loading="tableLoading"
              ref="table"
              :data="table.data"
              :columns="table.columns"></Table>
            <div style="margin: 10px 0; overflow: hidden;">
              <div style="float: left;">
                当前显示 {{ table.data.length }} 条记录，总共 {{ table.count }} 条记录
              </div>
              <div style="float: right;">
                <page
                  :total="table.count"
                  :current="table.page"
                  :page-size="table.size"
                  @on-change="getTableData"></page>
              </div>
            </div>
        </Card>
      </Col>
   </Row>
  </div>
</template>

<script>
import nodeList from './node-list'
import { getDomainLst, checkDnsRecord, createDnsRecordBatch, checkDnsRecordBatch, purchaseDomain } from '@/api/opscenter'
import DnsRecord from './DnsRecord'
import DnsRecordList from './DnsRecordList'
// import moment from 'moment'

export default {
  components: {
    nodeList,
    DnsRecord,
    DnsRecordList
  },
  data () {
    return {
      company: '傲基',
      dnsTarget: 'aliyun',
      loadingConfig: false,
      loadingCheck: false,
      selectObj: [],
      selectRow: [],
      defaultDomains: ['us', 'ca', 'de', 'fr', 'uk', 'es', 'it', 'jp'],
      selectNodes: [],
      nodeListSpan: 4,
      contentSpan: 20,
      nodesList: [],
      nodeListShow: true,
      groupId: null,
      node: null,
      tableLoading: false,
      tableSearchForm: {
        name: ''
      },
      table: {
        data: [],
        columns: [
          {
            title: '选中',
            align: 'center',
            minWidth: 60,
            key: 'checkBox',
            render: (h, params) => {
              let disabled = false
              if (!params.row.name) {
                disabled = true
              }
              let isCheck = false
              if (this.selectRow.indexOf(params.row.name) > -1) {
                isCheck = true
              }
              return h('div', [
                h('Checkbox', {
                  props: {
                    value: isCheck,
                    disabled: disabled
                  },
                  on: {
                    'on-change': (e) => {
                      this.table.data[params.index].checkBox = e
                      if (e) {
                        console.log(params.row)
                        if (this.selectRow.indexOf(params.row.name) < 0) {
                          this.selectRow.push(params.row.name)
                          this.selectObj.push(params.row)
                        }
                      } else {
                        this.removeServer(null, params.row.name)
                      }
                    }
                  }
                })
              ])
            }
          },
          {
            title: '名称',
            key: 'name',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            minWidth: 100,
            title: '域名状态',
            align: 'center',
            key: 'status',
            render: (h, params) => {
              const row = params.row
              const color = row.status === 'expired' ? 'error' : 'success'
              const text = row.status === 'expired' ? '已过期' : '正常'
              // 未安装， 正常， 异常
              return h('Tag', {
                props: {
                  type: 'dot',
                  color: color
                }
              }, text)
            }
          },
          // {
          //   title: '过期时间',
          //   key: 'ExpirationDate',
          //   align: 'center',
          //   tooltip: true,
          //   minWidth: 250
          // },
          {
            title: '操作',
            align: 'center',
            width: 360,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'success',
                    size: 'small'
                    // disabled: !(['1', '3'].indexOf(params.row.DomainStatus) > -1)
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$refs.dnsRecord.show(params.row.name, params.row.node, this.company, params.row.registrar)
                    }
                  }
                }, '配置解析'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'left',
                    title: '默认监测7个默认的二级域名'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    'on-ok': () => {
                      this.domainCheck(params.row.name, params.row.node, this.company)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'warning',
                      size: 'small'
                    }
                  }, '验证DNS')
                ]),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$refs.DnsRecordList.show(params.row.name)
                    }
                  }
                }, '查看域名解析状态'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'left',
                    title: '你确定要购买吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.domainPurchase(params.row.name, params.row.node)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small',
                      disabled: params.row.DomainStatus
                    }
                  }, '立即注册')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 10
      },
      listError: false
    }
  },
  created: function () {
    this.getTableData()
    this.nodeListShowBtn(true)
  },
  methods: {
    // 批量配置DNS解析
    batchConfig () {
      this.loadingConfig = true
      console.log(this.selectObj)
      // this.$refs.dnsRecord.batchShow(this.selectObj)
      let data = {
        domains: this.selectObj,
        company: this.company,
        dnsTarget: this.dnsTarget
      }
      createDnsRecordBatch(data).then(res => {
        this.$Notice.success({
          title: '操作成功！'
        })
        this.loadingConfig = false
      }).catch(res => {
        this.loadingConfig = false
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    // 批量监测DNS
    batchCheck () {
      this.loadingCheck = true
      console.log(this.selectObj)
      // this.$refs.dnsRecord.batchShow(this.selectObj)
      let data = {
        domains: this.selectObj,
        company: this.company
      }
      checkDnsRecordBatch(data).then(res => {
        this.$Notice.success({
          title: '操作成功！'
        })
        this.loadingCheck = false
      }).catch(res => {
        this.loadingCheck = false
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    // 清空选中的服务器
    emptyServer () {
      for (let i in this.table.data) {
        this.table.data[i].checkBox = false
      }
      this.selectRow = []
    },
    // 移除选中的服务器
    removeServer (event, domain) {
      if (event) {
        for (let i in this.table.data) {
          if (this.table.data[i].name === domain) {
            this.table.data[i].checkBox = false
            const index1 = this.selectObj.indexOf(this.table.data[i])
            this.selectObj.splice(index1, 1)
            break
          }
        }
      }
      const index = this.selectRow.indexOf(domain)
      this.selectRow.splice(index, 1)
    },
    domainPurchase (name, node) {
      console.log('开始购买域名')
      let data = {
        name: name,
        node: node
      }
      purchaseDomain(data).then(res => {
        this.$Notice.success({
          title: '购买成功！'
        })
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    domainCheck (name, node, company) {
      console.log('开始域名检查DNS')
      let domains = this.defaultDomains.map(item => item + '.' + name)
      let data = {
        names: domains,
        node: node,
        company: company
      }
      console.log(data)
      checkDnsRecord(data).then(res => {
        this.$Notice.success({
          title: '操作成功！'
        })
        this.submitLoading = false
        this.cancelModal()
      }).catch(res => {
        this.submitLoading = false
        this.cancelModal()
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    init (value) {
      this.selectNodes = value
      this.getTableData()
    },
    nodeListShowBtn (status) {
      this.nodeListShow = status
      if (status) {
        if (this.screenWidth < 1025) {
          this.nodeListSpan = 8
          this.contentSpan = 16
        } else {
          this.nodeListSpan = 4
          this.contentSpan = 20
        }
      } else {
        this.nodeListSpan = 0
        this.contentSpan = 24
      }
    },
    onResultChange (val) {
    },
    getTableData (value = 1) {
      this.table.page = value
      this.tableLoading = true
      this.tableSearchForm['size'] = this.table.size
      this.tableSearchForm['page'] = this.table.page
      this.tableSearchForm['name'] = this.tableSearchForm.name
      this.tableSearchForm['username'] = this.selectNodes.join(',')
      getDomainLst(this.tableSearchForm).then(res => {
        let result = res.data
        this.table.data = result.results
        this.table.count = result.count
        this.tableLoading = false
        this.listError = false
      }).catch(res => {
        this.tableLoading = false
        console.log(res.response)
        this.listError = true
      })
    },
    delete (row) {
      // logicDeleteGitlab(row.id).then(res => {
      //   this.$Notice.success({ title: '操作成功！' })
      //   this.getTableData(this.table.page)
      // }).catch(res => {
      //   console.log(res.response)
      //   if (res.request) {
      //     this.$Notice.error({
      //       title: '删除失败！',
      //       desc: res.request.responseText
      //     })
      //   } else {
      //     this.$Notice.error({
      //       title: '删除失败！'
      //     })
      //   }
      // })
    },
    clearSearchForm () {
      this.tableSearchForm = {
        name: ''
      }
    },
    // 编辑完成
    editComplete (isUpdate) {
      // if (isUpdate) {
      //   this.getTableData()
      // } else {
      //   this.getTableData(this.table.page)
      // }
    }
  }
}
</script>

<style scoped>

</style>
